import { Component, OnInit } from '@angular/core';

interface StatusTemp {
	name: string;
	btnName: string;
	steps: StepTemp[];
	toState: any[];
	isLast: boolean; // whether add the line after the status
}
interface StepTemp {
	stName: string;
	imageUrl: string;
}

@Component({
	selector: 'app-content-user-guide',
	templateUrl: './content-user-guide.component.html',
	styleUrls: ['./content-user-guide.component.css']
})
export class ContentUserGuideComponent implements OnInit {
	public status: StatusTemp[];
	public selectedStatus;
	public selectedStep;
	public image: string;
	constructor() { }
	getGuideContent(selected) {
		this.selectedStatus = selected;
		this.getStepContent(selected.steps[0]);
	}
	getStepContent(step) {
		this.selectedStep = step;
	}
	ngOnInit() {
		this.status = [
			{
				name: 'Intro',
				btnName: '',
				toState: [''],
				isLast: false,
				steps: []
			},
			{
				name: 'Load',
				btnName: 'Start Loading',
				toState: ['/azgiv/jobs/add-files'],
				isLast: false,
				steps: [
					{
						stName: 'Step 1',
						imageUrl: 'assets/css/img/userGuide_img/AZGIV-load-001.png'
					}, {
						stName: 'Step 2',
						imageUrl: 'assets/css/img/userGuide_img/AZGIV-load-002.png'
					}, {
						stName: 'Step 3',
						imageUrl: 'assets/css/img/userGuide_img/AZGIV-load-003.png'
					}, {
						stName: 'Step 4',
						imageUrl: 'assets/css/img/userGuide_img/AZGIV-load-004.png'
					}, {
						stName: 'Step 5',
						imageUrl: 'assets/css/img/userGuide_img/AZGIV-load-005.png'
					}
				]
			},
			{
				name: 'Review',
				btnName: 'Start Reviewing',
				toState: ['/azgiv/review/data-view/'],
				isLast: false,
				steps: [
					{
						stName: 'Step 1',
						imageUrl: 'assets/css/img/userGuide_img/AZGIV-review-001.png'
					}, {
						stName: 'Step 2',
						imageUrl: 'assets/css/img/userGuide_img/AZGIV-review-002.png'
					}
				]
			},
			{
				name: 'QC',
				btnName: 'Start QCing',
				toState: ['/azgiv/dashboard'],
				isLast: false,
				steps: [
					{
						stName: 'Step 1',
						imageUrl: 'assets/css/img/userGuide_img/AZGIV-QC-001.png'
					}, {
						stName: 'Step 2',
						imageUrl: 'assets/css/img/userGuide_img/AZGIV-QC-002.png'
					}
				]
			},
			{
				name: 'Submit',
				btnName: 'Start Submitting',
				toState: [''], // toDo
				isLast: true,
				steps: [
					// {
					// 	stName: 'Step 1',
					// 	imageUrl: ''
					// }, {
					// 	stName: 'Step 2',
					// 	imageUrl: ''
					// }, {
					// 	stName: 'Step 3',
					// 	imageUrl: ''
					// }, {
					// 	stName: 'Step 4',
					// 	imageUrl: ''
					// }
				]
			}
		];
		this.getGuideContent(this.status[0]);
		this.getStepContent(this.status[0].steps[0]);
	}

}
